import { render } from "./EditCategoriePage.vue?vue&type=template&id=6777f4f4&ts=true"
import script from "./EditCategoriePage.vue?vue&type=script&lang=ts"
export * from "./EditCategoriePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__